import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class UpLeftArrowIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 20 20"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path
					d="M 16.769,12.496 L
					3.687,16.385
					7.577,3.304
					9.875,5.602
					14.117,1.359
					18.713,5.955
					14.471,10.198
					16.769,12.496 Z"
					style={{
						fill: this.props.color,
						fillOpacity: 0.5,
						stroke: "#000000",
						strokeWidth: 1,
						strokeOpacity: 1,
						transformOrigin: "center",
						transform: "rotate(90deg)"
					}}/>
			</svg>
		);
	}
}